import { useState } from "react";
import { useBookingsStore } from "../../context/useBookingsStore";

export default function BookingReturnModal({
  booking,
  onClose,
  onDone,
}) {
  const { returnBooking } = useBookingsStore();

  const [manual, setManual] = useState({
    endOdometer: "",
    endFuelLevel: "",
    endCondition: "good",
    conditionNotes: "",
  });

  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  async function submit() {
    setError(null);

    if (!manual.endOdometer) {
      setError("End odometer is required");
      return;
    }

    try {
      setSubmitting(true);
      await returnBooking(booking.id, {
        ...manual,
        endOdometer: Number(manual.endOdometer),
        endFuelLevel:
          manual.endFuelLevel !== ""
            ? Number(manual.endFuelLevel)
            : undefined,
      });
      onDone();
    } catch (e) {
      setError(e.message || "Failed to return vehicle");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="modal">
      <h3 className="text-lg font-semibold mb-2">
        Return Vehicle
      </h3>

      {error && (
        <div className="text-red-600 text-sm mb-2">
          {error}
        </div>
      )}

      <input
        placeholder="End odometer"
        type="number"
        value={manual.endOdometer}
        onChange={(e) =>
          setManual({
            ...manual,
            endOdometer: e.target.value,
          })
        }
      />

      <input
        placeholder="Fuel level (%)"
        type="number"
        value={manual.endFuelLevel}
        onChange={(e) =>
          setManual({
            ...manual,
            endFuelLevel: e.target.value,
          })
        }
      />

      <select
        value={manual.endCondition}
        onChange={(e) =>
          setManual({
            ...manual,
            endCondition: e.target.value,
          })
        }
      >
        <option value="excellent">excellent</option>
        <option value="good">good</option>
        <option value="fair">fair</option>
        <option value="poor">poor</option>
      </select>

      <textarea
        placeholder="Condition notes"
        value={manual.conditionNotes}
        onChange={(e) =>
          setManual({
            ...manual,
            conditionNotes: e.target.value,
          })
        }
        rows={3}
      />

      <div className="mt-3 flex gap-2">
        <button onClick={submit} disabled={submitting}>
          {submitting ? "Saving..." : "Confirm"}
        </button>
        <button className="secondary" onClick={onClose}>
          Cancel
        </button>
      </div>
    </div>
  );
}
